import React from 'react';
import EstablishmentManagement from '../Management';

const EditEstablishment = () => (
    <EstablishmentManagement
        headerName="Atualizar Estabelecimento"
    />
);

export default EditEstablishment;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/Edit/index.js